import { render } from "./ArqueoCajaPage.vue?vue&type=template&id=dc8b44aa&scoped=true"
import script from "./ArqueoCajaPage.vue?vue&type=script&lang=js"
export * from "./ArqueoCajaPage.vue?vue&type=script&lang=js"

import "./ArqueoCajaPage.vue?vue&type=style&index=0&id=dc8b44aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc8b44aa"]])

export default __exports__